export const ADMINS_FIELDS = 'resources.admins.fields'
export const ROLES_FIELDS = 'resources.roles.fields'
export const EMAILCONFIG_FIELDS = 'resources.emailconfig.fields'
export const COMMON_FIELDS = 'resources.common.fields'
export const IMPORT_FIELDS = 'resources.import.fields'
export const SERVICES_FIELDS = 'resources.services.fields'
export const BRANCHCONFIG_FIELDS = 'resources.branchconfig.fields'
export const BRANCHCONFIG_OVERRIDE_FIELDS = 'resources.branchconfig.fields'
export const BOOKINGVIEW_FIELDS = 'resources.bookingview.fields'
export const TEMPORARYREQUEST_FIELDS = 'resources.temporaryrequest.fields'